import { Col, DatePicker, Form, Row, TimePicker } from 'antd'
import { useUpdateLeagueGame } from 'api/league/leagueGames/leagueGames'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { convertTimeToUtcMinutes } from 'helper/utility'
import moment from 'moment'
import React from 'react'
import { leagueGamesStore } from 'state/league/leageGames'
import { leagueEventStore } from 'state/league/leagueEvent'
import { myStore } from 'state/store'

const EditTimeModal = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { leagueData } = leagueEventStore(store => ({
    leagueData: store.leagueData,
  }))
  const { editTimeModal, setEditTimeModal, selectedGame, setSelectedGame } =
    leagueGamesStore(store => ({
      editTimeModal: store.editTimeModal,
      setEditTimeModal: store.setEditTimeModal,
      selectedGame: store.selectedGame,
      setSelectedGame: store.setSelectedGame,
    }))
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)

  const { mutate: updateLeagueGame } = useUpdateLeagueGame()

  const formSchema = {
    date: selectedGame ? moment(selectedGame.date) : null,
    time: selectedGame ? moment(selectedGame.date) : null,
  }

  const handleClose = () => {
    setSelectedGame(null)
    setEditTimeModal(false)
  }
  const disabledDate = (current: moment.Moment) => {
    if (!leagueData?.datesOfEvent || leagueData.datesOfEvent.length === 0) {
      return false
    }
    const currentDateStr = current.format('YYYY-MM-DD')
    return !leagueData.datesOfEvent.some(eventDate => {
      const eventDateStr = moment(eventDate).format('YYYY-MM-DD')
      return eventDateStr === currentDateStr
    })
  }

  const handleFinish = values => {
    const payload = {
      date: values.date
        ? moment
            .utc(
              `${moment(values.date).format('YYYY-MM-DD')} ${moment
                .utc(values.time)
                .format('HH:mm')}`,
            )
            .format()
        : undefined,
      timings: {
        startTime: convertTimeToUtcMinutes(values.time),
        endTime: undefined,
      },
    }
    setModalBtnLoader(true)

    updateLeagueGame(
      { payload: payload as any, gameId: selectedGame._id },
      {
        onSuccess: () => {
          setModalBtnLoader(false)
          handleClose()
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      },
    )
  }

  return (
    <>
      <CustomModal
        openModal={editTimeModal}
        isCloseModalCustom
        closeModal={handleClose}
        title="Edit time"
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save time"
            closeModal={handleClose}
            onSubmit={handleSubmit}
          />
        }
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={formSchema}
          onFinish={handleFinish}
        >
          <Row gutter={20}>
            <Col span={24}>
              <label htmlFor="" className="input-label">
                Date
              </label>
              <Form.Item
                name="date"
                rules={[{ required: true, message: 'Date is required' }]}
              >
                <DatePicker
                  className="w-100 form-control-field"
                  placeholder="MM/DD/YYYY"
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <label htmlFor="" className="input-label">
                Time
              </label>
              <Form.Item
                name="time"
                rules={[{ required: true, message: 'Time is required' }]}
              >
                <TimePicker
                  format={'hh:mm a'}
                  className="w-100 form-control-field"
                  placeholder="HH:MM AM/PM"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </CustomModal>
    </>
  )
}

export default EditTimeModal
